import React, { Fragment } from "react";
import { isMobile } from "react-device-detect";

import ConditionWrapper from "components/ConditionWrapper";
import CatchThumb from "components/boards/post/catch/CatchThumb";
import PostLink from "components/boards/post/PostLink";
import PostMoreButton from "components/boards/post/PostMoreButton";

const CatchItem = ({
    vod = {},
    authority = {},
    inflowPath,
    moreButtonTop,
    page,
    loading = false,
    pageType,
    showCatchInfo = true,
    catchCreated = true,
    location = '',
    onDestroyPin = {}
}) => {
    if (loading) {
        return (
            <>
                {!isMobile && (
                    <div className="grid">
                        <div></div>
                        <div className="list"><span></span><span></span></div>
                    </div>
                )}

                {isMobile && (
                   <div className="grid"></div>
                )}
            </>
        );
    }

    return (
        <Fragment>
            {/* 캐치 세로형 썸네일 노출 */}
                <CatchThumb
                    inflowPath={inflowPath}
                    vod={vod}
                    authority={authority}
                    page={page}
                    pageType={pageType}
                    showCatchInfo={showCatchInfo}
                    catchCreated={catchCreated}
                    location={location}
                    onDestroyPin={onDestroyPin}
                />
            {/* vod 컨트롤 버튼 (3dot) */}
            <PostMoreButton post={vod} authority={authority} top={moreButtonTop} right={0} pageCreated={catchCreated} />
        </Fragment>
    );
};

export default CatchItem;
